import GameGrid from '../components/GameGrid';

export default function Games() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold px-1">All games</h2>
      <GameGrid />
    </div>
  );
}
